<template>
  <a-input
    ref="inputRef"
    :max-length="40"
    v-model:value="inputValue"
    @input="formatNamesSurnames"
    @focusout="focusOutHandler"
    v-bind="$attrs"
  >
    <template #suffix>
      <a-button
        type="link"
        @click="clearInput"
        style="padding: 0; margin: 0; width: 20px; height: 20px; line-height: 1"
        tabindex="-1"
      >
        <DeleteOutlined class="red-icon" v-show="inputValue" />
      </a-button>
    </template>
  </a-input>
</template>

<script>
import { ref, computed, nextTick } from 'vue';
import nameSurnameHelper from '@/utils/nameSurname';
import { DeleteOutlined } from '@ant-design/icons-vue';

export default {
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    DeleteOutlined
  },
  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const inputRef = ref(null);

    const inputValue = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val)
    });

    const formatNamesSurnames = () => {
      if (inputValue.value) {
        const formatted = nameSurnameHelper.formatNameSurname(
          inputValue.value,
          false
        );
        if (formatted !== inputValue.value) {
          emit('update:modelValue', formatted);
        }
      }
    };

    const focusOutHandler = () => {
      if (inputValue.value) {
        const trimmed = nameSurnameHelper.formatNameSurname(
          inputValue.value,
          true
        );
        if (trimmed !== inputValue.value) {
          emit('update:modelValue', trimmed);
        }
      }
    };

    const clearInput = () => {
      emit('update:modelValue', '');
      nextTick(() => {
        inputRef.value?.focus();
      });
    };

    return {
      inputValue,
      focusOutHandler,
      formatNamesSurnames,
      clearInput,
      inputRef
    };
  }
};
</script>
